import _ from 'lodash'

export const sessionIdSelector = (state) => state.getIn(['authorization', 'sessionId'])
export const groupStackSelector = (state) => state.getIn(['ui', 'groupStack'])
export const actualPagesSelector = (state) => state.getIn(['ui', 'groupStack', 'groupData', 'pages'], 1)
export const currentLocaleSelector = (state) => state.getIn(['translate', 'locale'])
export const groupMembersSelector = (state, groupId) =>
    state.getIn(['ui', 'entityStack', 'groups', 'groups']).find((group) => _.toString(group.get('id')) === groupId)
